import React from "react";

import { AvatarProfile, Text, TextDate } from "@performyard/py-components";
import { GetSurveyParticipantsResponseJson } from "@performyard/service-contracts";

import useSearchQueryParams from "../../../../../../../../../hooks/useSearchQueryParams";

import { searchParamsSchema } from "../utils";

type RespondentListEntryProps = {
	participant: GetSurveyParticipantsResponseJson["participants"][number];
};

const RespondentListEntry = ({ participant }: RespondentListEntryProps) => {
	const { queryParams: searchParams, handleQueryChange: setSearchParams } = useSearchQueryParams({
		schema: searchParamsSchema,
	});

	const isSelected = participant._id === searchParams?.employeeId;

	return (
		<li
			role="option"
			aria-selected={isSelected}
			data-selected={isSelected}
			className="group border-b border-solid border-neutral-2"
		>
			<button
				type="button"
				aria-label={`View response from ${participant.name}`}
				aria-current={isSelected ? "true" : undefined}
				data-selected={isSelected}
				className="w-full cursor-pointer border-none bg-transparent px-4 py-2 text-left group-data-[selected=true]:bg-neutral-1 hover:bg-neutral-1"
				onClick={() => setSearchParams({ employeeId: participant._id })}
			>
				<AvatarProfile
					noLink
					employeeId={participant._id}
					employeeName={participant.name}
					avatarSize={24}
					textSize="paragraph-3"
					textWeight="regular"
				/>
				<div className="pl-7">
					<Text overrideElement="span" color="neutral-5" size="caption" weight="regular">
						Submitted at:{" "}
					</Text>
					<TextDate
						overrideElement="span"
						color="neutral-5"
						weight="regular"
						size="caption"
						date={new Date(participant.submittedAt)}
						dateSize="small"
					/>
				</div>
			</button>
		</li>
	);
};

export default RespondentListEntry;
